import React, { useState } from 'react';
import { Smartphone, Lock, Copy, Check, ExternalLink, Shield } from 'react-feather';

const EventGuardAccess = ({ event }) => {
  const [copiedPin, setCopiedPin] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);

  const scannerLink = `${window.location.origin}/qr-scanner`;
  const pinCode = event.access_pin || "------";

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === 'pin') {
      setCopiedPin(true);
      setTimeout(() => setCopiedPin(false), 2000);
    } else {
      setCopiedLink(true);
      setTimeout(() => setCopiedLink(false), 2000);
    }
  };

  return (
    <div className="w-full bg-[#111] border border-white/10 rounded-2xl overflow-hidden mt-6">
      
      {/* HEADER DEL APARTADO */}
      <div className="p-6 border-b border-white/5 bg-gradient-to-r from-[#161616] to-transparent">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/10 rounded-lg text-blue-400">
            <Shield size={20} />
          </div>
          <div>
            <h2 className="text-lg font-bold text-white leading-none">Acceso de Seguridad</h2>
            <p className="text-xs text-white/40 mt-1">Comparte estas credenciales solo con el personal de puerta.</p>
          </div>
        </div>
      </div>

      {/* CONTENIDO */}
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        
        {/* 1. SECCIÓN LINK AL SCANNER */}
        <div className="space-y-3">
          <label className="text-xs font-bold text-white/30 uppercase tracking-wider flex items-center gap-2">
            <Smartphone size={12} />
            Link del Escáner
          </label>
          
          <div className="group relative">
            <div className="w-full bg-black/50 border border-white/10 rounded-xl p-4 flex items-center justify-between transition-colors hover:border-white/20">
              <span className="text-sm text-white/70 truncate font-mono select-all">
                {scannerLink}
              </span>
              
              <div className="flex items-center gap-2">
                <a 
                  href="/qr-scanner" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 hover:bg-white/10 rounded-lg text-white/40 hover:text-white transition-colors"
                  title="Abrir en nueva pestaña"
                >
                  <ExternalLink size={16} />
                </a>
                <button 
                  onClick={() => copyToClipboard(scannerLink, 'link')}
                  className="p-2 bg-white/5 hover:bg-white/10 rounded-lg text-white transition-colors"
                >
                  {copiedLink ? <Check size={16} className="text-green-400" /> : <Copy size={16} />}
                </button>
              </div>
            </div>
          </div>
          <p className="text-[10px] text-white/30">
            Este link funciona en cualquier navegador móvil (Chrome/Safari).
          </p>
        </div>

        {/* 2. SECCIÓN PIN DE ACCESO */}
        <div className="space-y-3">
          <label className="text-xs font-bold text-white/30 uppercase tracking-wider flex items-center gap-2">
            <Lock size={12} />
            PIN de Evento
          </label>

          <div className="w-full bg-gradient-to-br from-blue-900/10 to-purple-900/10 border border-blue-500/20 rounded-xl p-3 flex items-center justify-between relative overflow-hidden">
             {/* Decoración de fondo */}
             <div className="absolute top-0 right-0 w-20 h-20 bg-blue-500/10 blur-2xl rounded-full pointer-events-none"></div>

             <div className="flex flex-col">
                <span className="text-4xl font-mono font-bold text-white tracking-[0.2em] drop-shadow-lg">
                    {pinCode}
                </span>
                <span className="text-[10px] text-blue-300/50 font-medium mt-1">
                    CREDENCIAL ÚNICA
                </span>
             </div>

             <button 
                onClick={() => copyToClipboard(pinCode, 'pin')}
                className="z-10 h-12 w-12 flex items-center justify-center bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 rounded-xl text-blue-400 transition-all active:scale-95"
             >
                {copiedPin ? <Check size={20} /> : <Copy size={20} />}
             </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default EventGuardAccess;